export {KISS_TARGET};

import {Watch} from '@acng/frontend-relativity';
import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {add, remove} from '@acng/frontend-bounty/style/element.js';
import {attributeSelector} from '@acng/frontend-bounty/dom/query.js';

import {ctxAmateur} from '../../amateurPool/context/amateur.js';

/**
 * @group DOM Attribute
 */
const KISS_TARGET = 'kiss-target';

AttributeSetup(KISS_TARGET, (name) => {
  const STYLE_KISS_PREFIX = 'kissAnimation';
  const watch = Watch(attributeSelector(name), ctxAmateur);

  AttributeLink(name, (element) =>
    watch(element, (element, amateur, previous) => {
      if (previous) {
        remove(element, `${STYLE_KISS_PREFIX}${previous.id}`);
      }

      if (amateur) {
        add(element, `${STYLE_KISS_PREFIX}${amateur.id}`);
      }
    })
  );
});
